import { TableField } from "../../types/table-field";

export const standardFields: TableField[] = [
  {
    name: "_id",
    label: {
      it: "ID Contratto",
      en: "Contract ID"
    },
    type: "text",
  },
  {
    name: "createdAt",
    label: {
      it: "Data",
      en: "Date"
    },
    type: "date",
  },
  {
    name: "operatorId",
    label: {
      it: "ID Operatore",
      en: "Operator ID"
    },
    type: "text",
  },
  {
    name: "contractType",
    label: {
      it: "Tipo",
      en: "Type"
    },
    type: "type",
  },
  {
    name: "campaignId",
    label: {
      it: "Campagna",
      en: "Campaign"
    },
    type: "text",
  },
  {
    name: "paymentMethodType",
    label: {
      it: "Pagamento",
      en: "Payment"
    },
    type: "type",
  },
  {
    name: "donationCause",
    label: {
      it: "Causa",
      en: "Cause"
    },
    type: "text",
  },
  {
    name: "donationAmount",
    label: {
      it: "Importo",
      en: "Amount"
    },
    type: "amount",
  },
  {
    name: "selectedAmount",
    label: {
      it: "Importo selezionato",
      en: "Selected amount"
    },
    type: "amount",
  },
  {
    name: "netAmount",
    label: {
      it: "Importo netto",
      en: "Net amount"
    },
    type: "amount",
  },
  {
    name: "status",
    label: {
      it: "Stato",
      en: "Status"
    },
    type: "type",
  }
]
